import { _ as __assign } from './chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { ThreadProvider } from './Thread/context.js';
import ThreadUI from './Thread/components/ThreadUI.js';
import { c as classnames } from './chunks/bundle-kFa80LJe.js';
import './chunks/bundle-CbXgxoLr.js';
import './chunks/bundle-mqagBpi9.js';
import './chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-DS1EhNtb.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DP3z2QNm.js';
import './chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import './withSendbird.js';
import './chunks/bundle-DRpjMk0B.js';
import './chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import 'react-dom';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-CjJk57u5.js';
import './ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-DdJ9pMWn.js';
import './useSendbirdStateContext.js';
import './chunks/bundle-BzR1dD25.js';
import './ui/SortByRow.js';
import './Thread/context/types.js';
import './chunks/bundle-CGb4JGZ-.js';
import './chunks/bundle-DXKWyDSR.js';
import './chunks/bundle-BW3AiewC.js';
import './chunks/bundle-C3wdhLEG.js';
import './Thread/components/ParentMessageInfo.js';
import './chunks/bundle-CewnJAub.js';
import './chunks/bundle-VPiE9Blu.js';
import './chunks/bundle-DcPIDUrE.js';
import './Thread/components/ParentMessageInfoItem.js';
import './ui/ImageRenderer.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';
import './ui/EmojiReactions.js';
import './ui/ReactionBadge.js';
import './ui/ReactionButton.js';
import './chunks/bundle-QsOiwa9F.js';
import './ui/BottomSheet.js';
import './ui/UserListItem.js';
import './chunks/bundle-DOfhjbKd.js';
import './chunks/bundle-C_zEpfCP.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './Message/context.js';
import './chunks/bundle-QgerWYLz.js';
import './ui/VoiceMessageItemBody.js';
import './ui/ProgressBar.js';
import './VoicePlayer/useVoicePlayer.js';
import './ui/PlaybackTime.js';
import './ui/Loader.js';
import './chunks/bundle-AV2qqH9G.js';
import './chunks/bundle-AmtSwuex.js';
import './ui/MentionLabel.js';
import './ui/LinkLabel.js';
import './chunks/bundle-X_IrklBY.js';
import './ui/FileViewer.js';
import './chunks/bundle-CH6t4mkR.js';
import './chunks/bundle-pv93aExN.js';
import './chunks/bundle-Dgu8bVmd.js';
import './chunks/bundle-CpMvhj21.js';
import './chunks/bundle-D2GzZ_yy.js';
import './ui/MessageItemReactionMenu.js';
import './ui/MessageInput.js';
import './chunks/bundle-GawAxqNK.js';
import 'dompurify';
import './chunks/bundle-B5pWUwTI.js';
import './chunks/bundle-CiR8AZTC.js';
import './chunks/bundle-Bs4dlPq1.js';
import './chunks/bundle-DwAJZ4P8.js';
import './ui/MobileMenu.js';
import './Message/hooks/useDirtyGetMentions.js';
import './chunks/bundle-B_14cMxa.js';
import './chunks/bundle-DCHZRHdl.js';
import './chunks/bundle-BJuj9G4S.js';
import './Thread/components/ThreadHeader.js';
import './ui/Header.js';
import './Thread/components/ThreadList.js';
import './Thread/components/ThreadListItem.js';
import './ui/DateSeparator.js';
import './chunks/bundle-w2yLrIlh.js';
import './chunks/bundle-jrZGOZ7u.js';
import './chunks/bundle-Dq0ggazV.js';
import './chunks/bundle-GdEa10s3.js';
import './ui/OGMessageItemBody.js';
import './ui/TextMessageItemBody.js';
import './ui/FileMessageItemBody.js';
import './ui/ThumbnailMessageItemBody.js';
import './chunks/bundle-CTVxl16S.js';
import './ui/UnknownMessageItemBody.js';
import './ui/TemplateMessageItemBody.js';
import './chunks/bundle-BcC0-Nxn.js';
import './ui/FallbackTemplateMessageItemBody.tsx.js';
import './ui/LoadingTemplateMessageItemBody.tsx.js';
import './ui/MessageFeedbackFailedModal.js';
import './chunks/bundle-rjBen5BS.js';
import './Channel/utils/compareMessagesForGrouping.js';
import 'date-fns';
import './Thread/components/ThreadMessageInput.js';
import './chunks/bundle-CHqSZaW8.js';
import './GroupChannel/components/SuggestedMentionList.js';
import './ui/QuoteMessageInput.js';
import './VoiceRecorder/useVoiceRecorder.js';
import './chunks/bundle-DoHO4wpB.js';
import './chunks/bundle-B5N-CojP.js';
import './GroupChannel/context.js';
import './chunks/bundle-BoENnpQQ.js';
import './chunks/bundle-3sZs8f9n.js';
import './Channel/hooks/useHandleUploadFiles.js';
import './ui/PlaceHolder.js';

var Thread = function (props) {
    var _a;
    return (React__default.createElement("div", { className: classnames('sendbird-thread', (_a = props === null || props === void 0 ? void 0 : props.className) !== null && _a !== void 0 ? _a : '') },
        React__default.createElement(ThreadProvider, __assign({}, props),
            React__default.createElement(ThreadUI, __assign({}, props)))));
};

export { Thread as default };
//# sourceMappingURL=Thread.js.map
